<template>
  <div v-if="!item.hidden">
    <div v-if="item.children && item.children.length">
      <!-- 特殊处理：根路由或主入口不显示父菜单，直接展示子菜单 -->
      <template v-if="isRootMain(item)">
        <sidebar-item
          v-for="child in item.children"
          :key="child.path"
          :is-nest="false"
          :is-root-child="true"
          :item="child"
          :base-path="resolvePath(item.path)"
        />
      </template>

      <template v-else>
        <el-submenu
          ref="subMenu"
          :index="resolvePath(item.path)"
          popper-append-to-body
          :default-openeds="[resolvePath(item.path)]"
          :collapse="true"
        >
          <template slot="title">
            <div @touchend="handleOpen()" style="text-align: start; padding-left: 10px;">
              <item
                v-if="item.meta"
                :icon="item.meta && item.meta.icon"
                :title="item.meta.title"
              />
            </div>
          </template>
          <sidebar-item
            v-for="child in item.children"
            :key="child.path"
            :is-nest="true"
            :item="child"
            :base-path="resolvePath(item.path)"
            class="nest-menu"
          />
        </el-submenu>
      </template>
    </div>
    <div v-else>
      <app-link v-if="item.meta" :to="resolvePath(item.path)">
        <el-menu-item :index="resolvePath(item.path)" :class="{ 'submenu-title-noDropdown': isRootChild }">
          <item v-if="item.meta" :icon="item.meta.icon" :title="item.meta.title" />
        </el-menu-item>
      </app-link>
    </div>
  </div>
</template>

<script>
import path from "path";
import { isExternal } from "@/utils/validate";
import Item from "./Item";
import AppLink from "./Link";
import FixiOSBug from "./FixiOSBug";

export default {
  name: "SidebarItem",
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    isRootChild: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: "",
    },
  },
  data() {
    this.onlyOneChild = null;
    return {};
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item;
          return true;
        }
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: "", noShowingChildren: true };
        return true;
      }

      return false;
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      return path.resolve(this.basePath, routePath);
    },
    linkTo(routePath){
      const _this=this;
      let path=_this.resolvePath(routePath);
      _this.$router.push(path);
    },
    handleOpen(key, keyPath) {
      //console.log(key, keyPath);
    },
    isRootMain(item) {
      if (!item) return false
      return item.path === '/' || item.name === 'Main' || (item.meta && item.meta.title === '')
    }
  },
};
</script>
<style scoped>
/* Ensure homepage single-item visually aligns with parent menu titles
   Match padding and icon spacing used by .el-submenu__title */
.submenu-title-noDropdown {
  padding-left: 30px !important; /* keep project default */
  display: flex !important;
  align-items: center !important;
}
.submenu-title-noDropdown .svg-icon,
.submenu-title-noDropdown .sub-el-icon,
.submenu-title-noDropdown svg-icon {
  margin-right: 16px !important; /* match .svg-icon spacing */
}
</style>
